import { modalFeedback, modalAboutVideo } from './modals/';

document.querySelectorAll('[data-modal]').forEach($button => {
  $button.addEventListener('click', event => {
    event.preventDefault();

    const type = $button.getAttribute('data-modal');

    switch (type) {
      case 'feedback':
        modalFeedback('show');
        break;

      case 'about_video':
        modalAboutVideo('show', 'https://www.youtube.com/embed/UMqKaO280n0');
        break;

      default:
        console.warn('There is no modal with key ' + type);
    }
  });
});

const recaptchaKey = '6LfidNwZAAAAAFq7gKDEs_zrU_ueETaHVBRyqx5p';

const initCaptcha = () => {
  return new Promise(resolve => {
    if (document.getElementById('captcha')) {
      return resolve();
    }

    const container = document.createElement('div');
    container.id = 'captcha';

    document.getElementsByTagName('body')[0].appendChild(container);

    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;

    document.getElementsByTagName('head')[0].appendChild(script);

    script.onload = () => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.render('captcha', {
          sitekey: recaptchaKey,
          size: 'invisible'
        });

        resolve();
      });
    };
  });
};

export const loadCaptcha = async $formNode => {
  await initCaptcha();

  return new Promise(async (resolve) => {
    window.grecaptcha.reset();
    await window.grecaptcha.execute();

    const checker = setInterval(() => {
      const token = window.grecaptcha.getResponse();

      if (token) {
        const $inputField = $formNode.querySelector('[name="g-recaptcha-response"]');

        if ($inputField) {
          $inputField.value = token;
        } else {
          const $input = document.createElement('input');
          $input.type = 'hidden';
          $input.name = 'g-recaptcha-response';
          $input.value = token;

          $formNode.appendChild($input);
        }

        clearInterval(checker);
        resolve(token);
      }
    }, 50);
  });
};

const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// функция валидации, на вход принимает ноду инпута
const validateField = $node => {
  let errorText = undefined;

  switch ($node.tagName) {
    case 'INPUT':
      const type = $node.type;
      const value = $node.value;

      switch (type) {
        case 'text':
          if (!value) {
            errorText = 'This is a required field';
          }
          break;

        case 'email':
          if (!value) {
            errorText = 'Please enter a valid email address';
          } else if (!emailRegExp.test(value)) {
            errorText = `This is not a valid email address`;
          }
          break;

        case 'checkbox':
          if (!$node.checked) {
            errorText = `This checkbox must be checked`;
          }
          break;
      }
      break;

    case 'SELECT':
      // TODO: Добавить проверок для селекта
      break;

    case 'TEXTAREA':
      if (!$node.value) {
        errorText = `This is a required field`;
      }
      break;
  }

  if (errorText) {
    $node.classList.add('is-invalid');

    const $error = document.createElement('div');
    $error.classList.add('invalid-feedback');
    $error.innerText = errorText;

    $node.parentNode.appendChild($error);
  }
};

export const validateForm = async $form => {
  return new Promise((resolve, reject) => {
    $form.querySelectorAll('.is-invalid').forEach($item => {
      $item.classList.remove('is-invalid');
    });

    $form.querySelectorAll('.invalid-feedback').forEach($item => {
      $item.remove();
    });

    for (let i=0; i < $form.elements.length; i++) {
      const $item = $form.elements[i];

      if (['INPUT','SELECT','TEXTAREA'].includes($item.tagName) && $item.hasAttribute('required')) {
        validateField($item);
      }
    }

    const errors = [];

    $form.querySelectorAll('.invalid-feedback').forEach($item => {
      errors.push($item.innerText);
    });

    if (errors.length) {
      return reject(errors.join('\n'));
    }

    return resolve();
  });
}